import { create } from "zustand";
import RepositoryManager from "../../data/repositoryManager";

const useLoginStore = create((set, get) => ({
  // Form state
  email: "kuncutelovely@gmail.com",
  password: "admin123",
  rememberMe: false,

  // UI state
  isLoading: false,
  error: null,
  formErrors: {},

  // Actions
  setEmail: (email) => set({ email }),
  setPassword: (password) => set({ password }),
  setRememberMe: (rememberMe) => set({ rememberMe }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
  setFormErrors: (formErrors) => set({ formErrors }),

  validateForm: () => {
    const { email, password } = get();
    const errors = {};

    if (!email) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = "Email is invalid";
    }

    if (!password) {
      errors.password = "Password is required";
    } else if (password.length < 6) {
      errors.password = "Password must be at least 6 characters";
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors,
    };
  },

  resetForm: () => {
    set({
      email: "",
      password: "",
      rememberMe: false,
      isLoading: false,
      error: null,
      formErrors: {},
    });
  },

  // Login action - tách logic từ component
  login: async (dataMainStore, navigate, toast) => {
    const { email, password, rememberMe, validateForm, setLoading, setError, setFormErrors, resetForm } = get();

    // Validate form
    const validation = validateForm();
    if (!validation.isValid) {
      setFormErrors(validation.errors);
      return { success: false, error: "Validation failed" };
    }

    setFormErrors({});
    setError(null);
    setLoading(true);

    try {
      const response = await RepositoryManager.auth.login({
        email,
        password,
        rememberMe,
      });

      // Set token and user in dataMainStore
      dataMainStore.setToken({
        token: response.data.access_token,
        refreshToken: response.data.refresh_token,
        tokenExpired: null, // API doesn't return expiration
        refreshTokenExpired: null, // API doesn't return expiration
      });
      dataMainStore.setUser(response.data.user);

      toast.success("Đăng nhập thành công!");
      resetForm();

      // Navigate to dashboard
      if (navigate) {
        navigate("/admin/dashboard", { replace: true });
      }

      return { success: true, data: response.data };
    } catch (err) {
      console.log("Lỗi đăng nhập:", err);
      const message =
        err?.response?.data?.msg || "Đăng nhập thất bại. Vui lòng thử lại.";
      setError(message);
      return { success: false, error: message };
    } finally {
      setLoading(false);
    }
  },
}));

export default useLoginStore;
